import VentaCodigoCargado from "./VentaCodigoCargado";

export default VentaCodigoCargado;
